// extracted by mini-css-extract-plugin
export default {"article":"Vision_article__Lpb1U","header":"Vision_header__5Xc0U"};